/**
 * Section A5 Service
 * A.5.技術及措施 API 服務
 *
 * 注意: axios 攔截器會自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axios from '../api/axios';

const BASE_URL = '/api/section_a5';

// 類型定義
export interface SectionA5Detail {
  id?: number;
  organization_id: number;
  project_id: number;
  project_existed_tech?: string;
  project_deployed_tech?: string;
  project_former?: string;
  a5_percentage: number;
  edit_by: number;
  created_at?: string;
  updated_at?: string;
}

export interface SectionA5Create {
  project_existed_tech?: string;
  project_deployed_tech?: string;
  project_former?: string;
}

export interface ProjectOption {
  id: number;
  title: string;
  organization_id: number;
  pdd_status: number;
}

const sectionA5Service = {
  /**
   * 取得可選專案清單
   * axios 攔截器會自動添加 X-Txn-Token header
   */
  getAvailableProjects: async (): Promise<ProjectOption[]> => {
    const response = await axios.get(`${BASE_URL}/projects`);
    return response.data;
  },

  /**
   * 取得專案的 A.5 資料
   * axios 攔截器會自動添加 X-Txn-Token header
   */
  getSectionA5: async (projectId: number): Promise<SectionA5Detail> => {
    const response = await axios.get(`${BASE_URL}/${projectId}`);
    return response.data;
  },

  /**
   * 儲存 A.5 資料
   * axios 攔截器會自動添加 X-Txn-Token header
   */
  saveSectionA5: async (
    projectId: number,
    data: SectionA5Create
  ): Promise<any> => {
    const response = await axios.post(`${BASE_URL}/${projectId}`, data);
    return response.data;
  }
};

export default sectionA5Service;
